import { Bug } from 'lucide-react';

/**
 * ReportBugLink - A clickable link to report bugs/problems
 * Opens the support system or navigates to contact page
 */
const ReportBugLink = ({ className = "", variant = "default" }) => {
  const handleClick = () => {
    // Try to open the floating support button
    const supportBtn = document.querySelector('[data-testid="floating-support-btn"]');
    if (supportBtn) {
      supportBtn.click();
      // After a small delay, try to click "Nous contacter" option
      setTimeout(() => {
        const contactOption = document.querySelector('[data-testid="support-contact-option"]');
        if (contactOption) {
          contactOption.click();
        }
      }, 300);
    } else {
      // Fallback: navigate to contact page
      window.location.href = '/contact';
    }
  };

  const baseStyles = "inline-flex items-center gap-1.5 text-sm cursor-pointer transition-colors";
  
  const variantStyles = {
    default: "text-gray-500 hover:text-brand-600",
    light: "text-gray-400 hover:text-gray-600",
    muted: "text-gray-400 hover:text-brand-500",
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${baseStyles} ${variantStyles[variant] || variantStyles.default} ${className}`}
      data-testid="report-bug-link"
    >
      <Bug className="h-3.5 w-3.5" />
      <span>Rapporter un problème</span>
    </button>
  );
};

export default ReportBugLink;
